<template>
  <div>
    <span v-html="answer.nameTagKey" />

    <div>
      <div v-if="answer.dependants && Object.keys(answer.dependants).length" class="mb-2">
        <small class="m-0 info-box bg-info">
          This response triggers:
          <template
            v-for="({ FK_questionKey, FK_answerKey, timer }, i) in Object.values(answer.dependants)"
          >
            <span :key="`trigger-${FK_questionKey}-${FK_answerKey}`">
              <span v-if="i !== 0">{{
                i === Object.values(answer.dependants).length - 1 ? ' and ' : ', '
              }}</span>
              <span class="clickable" @click="$EventBus.$emit('selectQuestion', FK_questionKey)">
                {{ questions[FK_questionKey].uniqueKey }}
              </span>
              <template v-if="timer > 0">
                <span class="fas fa-clock pl-5"></span>
                {{ timer | formatTime }} delay
              </template>
            </span>
          </template>
        </small>
      </div>
      <template v-for="{ FK_skillKey, FK_answerKey, points, sign } in answer.answerToSkill">
        <!-- Fix for a weird bug, when it shows points as positive when new answers and answer skills gets added BUG-5322 -->
        <template v-if="sign == '-1'">
          <small :key="`${FK_skillKey}-${FK_answerKey}`" class="m-0 mr-5 mb-5 info-box bg-danger">
            {{ skills[FK_skillKey].name }}:
            {{ `-${Math.abs(points)}` }}
          </small>
        </template>
        <template v-else>
          <small
            :key="`${FK_skillKey}-${FK_answerKey}`"
            :class="['m-0 mr-5 mb-5 info-box', points >= 0 ? 'bg-success' : 'bg-danger']"
          >
            {{ skills[FK_skillKey].name }}:
            {{ points | formatScore }}
          </small>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      answer: {
        type: Object,
        required: true,
      },
      skills: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      ...mapState('editMode/questions', ['questions']),
      ...mapState('editMode/characters', ['characters']),
    },
  };
</script>
<style lang="scss" scoped>
  small {
    font-style: normal;
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
    color: #0073ad !important;
  }
</style>
